import { AutogenModelEdiMonitor, AutogenRowEdiMonitor } from "./autogen/AutogenModelEdiMonitor";

export class ModelEdiMonitor extends AutogenModelEdiMonitor<RowEdiMonitor> {
	constructor() {
		super(RowEdiMonitor);
	}
}

export class RowEdiMonitor extends AutogenRowEdiMonitor {
}